import React from "react"

const Button = ({ onClick, children, variant, classes, disabled = false }) => {
    const getVariantStyle = () => {
        switch (variant) {
            case "primary":
                return "primary-button"
            case "secondary":
                return "secondary-button"
            case "neutral-button-outline":
                return "neutral-button-outline"
            case "neutral-button":
                return "neutral-button"
            case "round-button":
                return "round-button"
            default:
                return "primary-button"
        }
    }

    return (
        <button
            className={`${getVariantStyle()} ${classes}`}
            onClick={() => onClick()}
            disabled={disabled}
        >
            {children}
        </button>
    )
}

export default Button
